export const GRAPHQL_VARIABLES = {
  contentType: 'image/png'
};

export const QUERY = `
   query individualOne($filter: FilterFindOneindividualsInput!, $contentType: String!){
     individualOne(filter: $filter) {
         documentType
         licenceNumber
         jurisdiction
         additionalDocumentType
         title
         birth
         firstName
         lastName
         ownership
         address {
           address1
           address2
           address3
           state
           city
           zip
           country
           _id
         }
         email
         phone
         _id
         companyId
         enableDLBackSide
         driverLicence(contentType:$contentType){
           url
           contentType
           uploadUrl
         }
         passport(contentType:$contentType){
           url
	           contentType
           uploadUrl
         }
         utilityBill(contentType:$contentType){
           url
           contentType
           uploadUrl
         }
     }
 }
 `;
